import React from "react"

export class LoggedInUser {
  readonly id: string
  readonly name: string
  readonly email: string

  constructor(
    id: string,
    name: string,
    email: string
  ) {
    this.id = id
    this.name = name
    this.email = email
  }

  public isAuthenticated(): boolean {
    return this !== UnauthenticatedUser
  }
}

export const UnauthenticatedUser: LoggedInUser = new LoggedInUser(
  "",
  "",
  ""
)

export const UserContext = React.createContext<LoggedInUser>(UnauthenticatedUser)